<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Add Pharmacy",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Add Pharmacy",
            items: [
               {
                  text: "Pharmacy",
                  href: "/pharmacies",
               },
               {
                  text: "Add Pharmacy",
                  active: true,
               },        
            ],


            pharmacy: {
               id: null,
               name : "",
               phone: "",
               email: "",
               password: "",
               country_code: 1,
               pin_no: "",
               type: 1,
               clinic_id: null,
               limited_tokens:2,
               limited_tokens_count:"",
               content_type: 1, // default to Content A
            },
            image: "",
            preview_image: "",
            countries: [],
            clinics: [],
            pharmacy_content_A: "",
            pharmacy_content_B: "",


            pharmacy_location: '',
            pharmacy_marker: { position: { lat: null, lng: null } },
            pharmacy_center: { lat: null, lng: null },
            pharmacy_current_place: null,

            pharmacy_mapOptions: {
               disableDefaultUI: true,
            },

            errors: {},
            
            loading: false,
         };
      },
      mounted() {
         this.fetchCountryCodes();
         this.fetchClinics();
         this.fetchContents();
      },

      methods: {
         //sets the position of marker when dragged
         pharmacyHandleMarkerDrag(e) {
            this.pharmacy_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
         },

         //Moves the map view port to marker
         pharmacyPanToMarker() {
            this.$refs.pharmacyMapRef.panTo(this.pharmacy_marker.position);
            this.$refs.pharmacyMapRef.setZoom(18);
         },

         //Moves the marker to click position on the map
         pharmacyHandleMapClick(e) {
            this.pharmacy_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            console.log(e);
         },     

         pharmacySetPlace(place) {
            this.pharmacy_current_place = place;
            if(this.pharmacy_current_place) {
               const marker = {
                  lat: this.pharmacy_current_place.geometry.location.lat(),
                  lng: this.pharmacy_current_place.geometry.location.lng(),
               };
               this.pharmacy_center = marker;
               this.pharmacy_marker.position = marker;
               this.pharmacy_location = place.formatted_address;
            }
         },

         fetchContents() {
            let url = "api/admin/getContents";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.pharmacy_content_A = responseData.contents.pharmacy_content_A;
                  this.pharmacy_content_B = responseData.contents.pharmacy_content_B;
                  console.log(this.contents);
               })
               .catch((err) => console.log(err));
         },

         fetchCountryCodes() {
            let url = "api/admin/get-countries";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.countries = responseData.countries;
               })
               .catch((err) => console.log(err));
         },

         fetchClinics() {
              
            let url = "api/admin/tv_show/getClinics?type=" + 1;        
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.clinics = responseData.clinics;
               })
               .catch((err) => console.log(err));
         },
         
         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         }, 

         addpharmacy(){

            this.getToken();

            const config = {
               headers: {
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/addPharmacy";

            let formData = new FormData();
            formData.append("name", this.pharmacy.name);
            formData.append("type", this.pharmacy.type);
            if (this.pharmacy.type == 2) {
               formData.append("clinic_id", this.pharmacy.clinic_id);
            }
            formData.append("country_code", this.pharmacy.country_code);
            formData.append("mobile", this.pharmacy.phone);
            formData.append("email", this.pharmacy.email);
            formData.append("password", this.pharmacy.password);
            formData.append("address", this.pharmacy_location);
            formData.append("latitude", this.pharmacy_marker.position.lat);
            formData.append("longitude", this.pharmacy_marker.position.lng);
            formData.append("pin_no", this.pharmacy.pin_no); 
            formData.append('image', this.image);
            formData.append("limited_tokens", this.pharmacy.limited_tokens);
            formData.append("limited_tokens_count", this.pharmacy.limited_tokens_count);
            formData.append("content_type", this.pharmacy.content_type);
            
            this.loading = true;
            
            this.$axios
               .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.$router.push({ name: 'pharmacies' });
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        if(error.response.status == 422);{
                           this.$nextTick(() => {
                              const firstErrorField = document.querySelector('.is-invalid');
                              if (firstErrorField) {
                                 firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                 firstErrorField.focus();
                              }
                           });
                        }
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));

         },

         
         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },
         setFile(e) {
            this.image = e.target.files[0];
            this.preview_image = URL.createObjectURL(e.target.files[0]);
         }, 
      }
   }
</script>

<style scoped>
   .page-loader {
      display: flex;
      align-items: center;
      padding: 10px 0;
   }

   .page-loader img {
      width: 50px;
      height: 50px;
   }
</style>

    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'pharmacies' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form" @submit.prevent="addpharmacy()">
                        
                        <div class="row">
                           <b-col md="12" lg="6" class="form-group">
                              <pharmacyel class="control-pharmacyel">Name<span class="text-danger">*</span></pharmacyel>
                              <b-form-input v-model="pharmacy.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"></b-form-input>
                              <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group">
                              <pharmacyel class="control-pharmacyel">Phone<span class="text-danger">*</span></pharmacyel>
                              <b-input-group>
                                 <b-input-group-prepend>
                                    <select class="form-control" v-model="pharmacy.country_code"  v-bind:class="{ 'is-invalid': Boolean(errors.country_code) }">
                                       <option :value="country.id" v-for="country in countries" :key="country.id">{{country.country_code}}</option>
                                    </select>
                                 </b-input-group-prepend>
                                 <b-form-input v-model="pharmacy.phone" maxlength="15" @keypress="numbersOnly" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }"></b-form-input>
                                  <div v-for="(val, index) in errors.country_code" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                                 <div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                               </b-input-group>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group">
                              <pharmacyel class="control-pharmacyel">Email<span class="text-danger">*</span></pharmacyel>
                              <b-form-input v-model="pharmacy.email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"></b-form-input>
                              <div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>


                           <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Type <span class="text-danger">*</span></label>
                              <b-form-radio-group
                                 v-model="pharmacy.type"
                                 name="pharmacyType"
                                 :class="{ 'is-invalid': Boolean(errors.type) }"
                                 inline
                                 >
                                 <div class="form-check-inline">
                                 <b-form-radio :value="1">Individual</b-form-radio>
                                 </div>
                                 <div class="form-check-inline">
                                 <b-form-radio :value="2">Under Clinic</b-form-radio>
                                 </div>
                              </b-form-radio-group>

                              <div v-for="(val, index) in errors.type" :key="index" class="invalid-feedback d-block">
                                <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group" v-if="pharmacy.type == 2">
                              <pharmacyel class="control-pharmacyel">Clinic<span class="text-danger"></span></pharmacyel>
                              <select class="form-control" v-model="pharmacy.clinic_id"  v-bind:class="{ 'is-invalid': Boolean(errors.clinic_id) }">
                                 <option value="">Select Clinic</option>
                                 <option :value="clinic.id" v-for="clinic in clinics" :key="clinic.id">{{clinic.name}}</option>
                              </select>
                           </b-col>

                        <b-row>
                           <b-col md="12" lg="6" class="form-group d-flex align-items-center">
                              <b-form-checkbox
                                 v-model="pharmacy.limited_tokens"
                                 name="limited_tokens"
                                 value="1"
                                 unchecked-value="2"
                              >
                                 <span class="ms-2">Limited Tokens</span>
                              </b-form-checkbox>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group" v-if="pharmacy.limited_tokens==1">
                              <label class="control-label">Token Count<span class="text-danger">*</span></label>
                              <b-form-input v-model="pharmacy.limited_tokens_count" v-bind:class="{ 'is-invalid': Boolean(errors.limited_tokens_count) }"></b-form-input>
                            <div v-for="(val, index) in errors.limited_tokens_count" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </b-row>

                         <b-col md="12" class="form-group">
                              
                              <div class="row">
                                 <div class="col-md-6">
                                    <div class="card border" :class="{ 'border-primary': pharmacy.content_type === 1 }">
                                       <div class="card-body">
                                          <div class="form-check">
                                             <input class="form-check-input" type="radio" v-model="pharmacy.content_type" :value="1" name="labContentType" :class="{ 'is-invalid': Boolean(errors.content_type) }">
                                             <label class="form-check-label fw-bold">
                                                Content A
                                             </label>
                                          </div>
                                          <div class="mt-2">
                                             <small class="text-muted">{{ pharmacy_content_A || 'No content available' }}</small>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 
                                 <div class="col-md-6">
                                    <div class="card border" :class="{ 'border-primary': pharmacy.content_type === 2 }">
                                       <div class="card-body">
                                          <div class="form-check">
                                             <input class="form-check-input" type="radio" v-model="pharmacy.content_type" :value="2" name="labContentType" :class="{ 'is-invalid': Boolean(errors.content_type) }">
                                             <label class="form-check-label fw-bold">
                                                Content B
                                             </label>
                                          </div>
                                          <div class="mt-2">
                                             <small class="text-muted">{{ pharmacy_content_B || 'No content available' }}</small>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>

                              <div v-for="(val, index) in errors.content_type" :key="index" class="invalid-feedback d-block">
                                <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group">
                              <pharmacyel>Profile Image <span class="text-danger">*</span> <span class="small">[Allowed formats: .jpg, .jpeg, .png]</span></pharmacyel>

                              
                              <input type="file" @change="setFile($event)" accept=".png,.jpg,.jpeg" class="form-control" :class="{ 'is-invalid': Boolean(errors.image) }" />
                              <img v-if="preview_image" class="avatar-sm mt-2" :src="preview_image">

                              <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group" v-if="!edit">
                              <pharmacyel class="control-pharmacyel">Password<span class="text-danger">*</span></pharmacyel>
                              <b-form-input type="password" v-model="pharmacy.password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>
                              <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <div class="form-group col-md-6">
                                 <pharmacyel>Pin Number <span class="text-danger">*</span></pharmacyel>
                                 <b-form-input v-model="pharmacy.pin_no" @keypress="numbersOnly" autocomplete="off" maxlength="4" v-bind:class="{ 'is-invalid': Boolean(errors.pin_no) }"></b-form-input>

                                 <div v-for="(val, index) in errors.pin_no" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>

                           <b-col md="12" class="mb-3">
                              <pharmacyel class="control-pharmacyel">Location <span class="text-danger">*</span></pharmacyel>
                              <GmapAutocomplete @place_changed="pharmacySetPlace" class="form-control"  @keypress.enter="$event.preventDefault()" placeholder="Search here..."  :value="pharmacy_location"/>
                              
                              <GmapMap v-if="pharmacy_location"
                                 :center="pharmacy_center"
                                 :zoom="18"
                                 map-style-id="pharmacy-roadmap"
                                 :options="pharmacy_mapOptions"
                                 style="width: 100%; height: 50vmin"
                                 ref="pharmacyMapRef"
                                 @click="pharmacyHandleMapClick">
                                    <GmapMarker
                                       :position="pharmacy_marker.position"
                                       :clickable="true"
                                       :draggable="true"
                                       @drag="pharmacyHandleMarkerDrag"
                                       @click="pharmacyPanToMarker"
                                    />
                              </GmapMap>       
                              <div v-if="errors.address" class="invalid-feedback d-block">
                                 <p class="mb-0" v-for="(val, i) in errors.address" :key="i">{{ val }}</p>
                              </div>                   
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <pharmacyel class="control-pharmacyel">Latitude <span class="text-danger">*</span></pharmacyel>
                              <b-form-input v-model="pharmacy_marker.position.lat" v-bind:class="{ 'is-invalid': Boolean(errors.latitude) }"></b-form-input>
                              <div v-for="(val, index) in errors.latitude" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <pharmacyel class="control-pharmacyel">Longitude <span class="text-danger">*</span></pharmacyel>
                              <b-form-input v-model="pharmacy_marker.position.lng" v-bind:class="{ 'is-invalid': Boolean(errors.longitude) }"></b-form-input>
                              <div v-for="(val, index) in errors.longitude" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </div>

                        <div class="row mt-3">
                           <div class="12">
                              <div v-if="loading" class="page-loader">
                                 <img src="@/assets/images/preloaderspin.gif"/>
                              </div>
                              <div v-else>
                                 <button class="btn btn-primary me-2" type="submit">Save</button>
                                 <router-link :to="{ name: 'pharmacies' }" class="btn btn-light">Cancel</router-link>
                              </div>
                           </div>
                        </div>
                     </form>
                  </b-card>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
